import { Gender } from "../../generated/graphql";

export const genders = [
  { value: Gender.Man, label: "男性" },
  { value: Gender.Woman, label: "女性" },
  { value: Gender.Other, label: "その他" },
  { value: Gender.None, label: "回答しない" },
];
